import { createSelector } from 'reselect';
import { getIsDragDropEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getHasSubscriptionGroupsWriteAccess } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getIsAutomatedLike, getIsAutomatedForWorkflows, getCanLoadAutomation, getHasAccessToAutomationTabOnly, getCanUseAutomationOnRegularEmails
// @ts-expect-error not migrated yet
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getPaneState } from 'EmailEditorUI/redux/selectors/PaneStateSelectors';
import { getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';

// @ts-expect-error module not yet migrated
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
const EMAIL_FORM_FIELDS_LOCATION = {
  // content fields
  content: 'content',
  rssEmailBlogImageMaxWidth: 'content',
  rssEmailImageMaxWidth: 'content',
  rssEmailAuthorLineTemplate: 'content',
  smartContent: 'content',
  invalidModules: 'content',
  hsEmailBody: 'content',
  // inbox-settings fields
  ['inbox-settings']: 'inbox-settings',
  abSettings: 'inbox-settings',
  useRssTitleAsHeadline: 'inbox-settings',
  subject: 'inbox-settings',
  simpleAbSubjectA: 'inbox-settings',
  simpleAbSubjectB: 'inbox-settings',
  previewText: 'inbox-settings',
  from: 'inbox-settings',
  fromName: 'inbox-settings',
  replyTo: 'inbox-settings',
  customReplyTo: 'inbox-settings',
  // send-options fields
  ['send-options']: 'send-options',
  subscription: 'send-options',
  preferencesGroup: 'send-options',
  recipients: 'send-options',
  mailingIlsListsIncluded: 'send-options',
  mailingIlsListsExcluded: 'send-options',
  vidsIncluded: 'send-options',
  vidsExcluded: 'send-options',
  // schedule fields
  ['schedule']: 'schedule',
  publishing: 'schedule',
  publishDate: 'schedule',
  publishImmediately: 'schedule',
  rssSchedule: 'schedule',
  time: 'schedule',
  repeatsOnWeekly: 'schedule',
  repeatsOnMonthly: 'schedule',
  repeats: 'schedule',
  // setup fields
  ['setup']: 'setup',
  name: 'setup',
  campaign: 'setup',
  settings: 'setup',
  pageExpiry: 'setup',
  pageExpiryDate: 'setup',
  pageExpiryEnabled: 'setup',
  pageExpiryRedirectId: 'setup',
  pageExpiryRedirectUrl: 'setup',
  slug: 'setup',
  createPage: 'setup',
  webversion: 'setup',
  emailbodyPlaintext: 'setup',
  editFooter: 'setup',
  htmlTitle: 'setup',
  // automate fields
  ['automate']: 'automate',
  automation: 'automate'
};
export const paneStateSelector = property => createSelector([getPaneState], state => state[property]);
export const getIsCanSpamOpen = paneStateSelector('manageCanSpamOpen');
export const getIsCreditLimitReachedModalOpen = paneStateSelector('creditLimitReachedModalOpen');
export const getIsPlainTextModalOpen = paneStateSelector('plainTextModalOpen');
export const getIsVerifyEmailAddressModalOpen = paneStateSelector('verifyEmailAddressModalOpen');
export const getEmailAddressToVerify = paneStateSelector('emailAddressToVerify');
export const getIsBrandingModalOpen = paneStateSelector('brandingPql');
export const getIsExitWithChangesModalOpen = paneStateSelector('exitWithChangesModalOpen');
export const getIsReviewModalOpen = paneStateSelector('reviewModalOpen');
export const getIsContentRemixModalOpen = paneStateSelector('contentRemixModalOpen');
export const getShowImportContactsAlert = paneStateSelector('showImportContactsAlert');
export const getOpenedPopover = paneStateSelector('openedPopover');
export const getFormFieldLocationsByEditor = createSelector([getIsDragDropEmail, getHasSubscriptionGroupsWriteAccess], (isDragDropEmail, hasSubscriptionGroupsWriteAccess) => {
  const footerSettingsLocation = isDragDropEmail && !hasSubscriptionGroupsWriteAccess ? 'content' : 'setup';
  return Object.assign({}, EMAIL_FORM_FIELDS_LOCATION, {
    canSpamSettings: footerSettingsLocation,
    editFooter: footerSettingsLocation
  });
});
export const getShouldRedirectToVersionA = createSelector([getIsABVariant, getHasAccessToAutomationTabOnly], (isABVariant, hasAccessToAutomationTabOnly) => isABVariant && hasAccessToAutomationTabOnly);
export const getIsAutomateTabAvailable = createSelector([getCanLoadAutomation, getCanUseAutomationOnRegularEmails], (canLoadAutomation, canUseAutomationOnRegularEmails) => {
  return canLoadAutomation && canUseAutomationOnRegularEmails;
});
export const getIsAutomateRouteAvailable = createSelector([getIsAutomateTabAvailable, getIsABVariant], (isAutomateTabAvailable, isABVariant) => isAutomateTabAvailable && !isABVariant);
export const getIsScheduleTabAvailable = createSelector([getCanLoadAutomation, getIsAutomatedForWorkflows, getIsAutomatedLike], (canLoadAutomation, isAutomatedForWorkflows, isAutomatedLike) => {
  return !(canLoadAutomation && isAutomatedForWorkflows) && !isAutomatedLike;
});
export const getIsScheduleRouteAvailable = createSelector([getIsScheduleTabAvailable, getIsABVariant], (isScheduleTabAvailable, isABVariant) => {
  return isScheduleTabAvailable && !isABVariant;
});
export const getIsNotContentRoute = createSelector([getRoutingCurrentPage], routingCurrentPage => routingCurrentPage !== 'content');
export const getIsAutomateRoute = createSelector([getRoutingCurrentPage], routingCurrentPage => routingCurrentPage === 'automate');